var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "icons8_tracking_30px_1",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABHNCSVQICAgIfAhkiAAAAn1JREFUSEvFlstrE1EUxr9zM3XhRrrUWm9SiVD3Jg1qUTdioRvbhkwSN/o3uOhGpYvi0lV34moSH6iIpbpRUNGZQbPSRemiifVVEIQGJZhM5spEU8Y85hntrMLce84v5zvnu3NJCIGdeGhHwUTUVXS5kHxOwHEXNRoA1gBaA7DSkIYexNMvvvaK6SywVXEIcCejSoIW68PD1+JTj37aFz2D7UGVQuIUQE98zIKKpjETPVf60o4JBF5XjkwyYs98gAFBG4xFUgfkl5+tOFewx956/Q9vIhKbHE2rtf8NBgGXeVZfcAVbpZSVxGkieuy1LJd9WxGJje2fe/XNvq/nVAfqqQNdAOejsnajC1wpTnjxbDuuIYBLQkSK1guipkzAAoCh/my6z2X1bCiwAOZjWf2qPUm5kJwnYNGh6FUua+OuUjv5lpE00rZIO9GH26mRpmF+dABXuaztcQU79VhI5t5Y+vWmPclG8eg+UxifHMA1Lmu7+4K9eDiQ1IQyz2hjocAAWsNlSLuuW4kko37BdbgI93hGm3GV2toQ4Hx2svMsl7W7nsAD9PLmD+k7Pzz3rh5Wan8HmqB8NKcpjkeml+HyRSVajsratKevU6/EQfotgLeGiWPxvF4NDPbbbwsqSezMaFrd9ranr1O76kDSEy03I438wXRpy65eKLB1Ee6+Fm6nr4FwkWf0JSJ03Zl9gTv7Xbk5MQ5TrACI/rVGKAvBpmJZdbXf8IUCW0nXlVSCkakCYH8gJgkkeE4vOU18aPDvUy15B8Cs9ZsEbvGcnnGz2WDASvIkCE9bNgE7EcuqrjfQgYDFFbD3h5IPLS6X9elew9SpQE+wm0z/Yv0XxjFs1BEqMe8AAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowIcon);
export default __webpack_public_path__ + "static/media/followIcon.da5e03612daf278c37dd97dfa5aee93f.svg";
export { ForwardRef as ReactComponent };